{
  "tags": [
    {
      "value": "general",
      "name": {
        "de": "Allgemein",
        "en": "General"
      }
    },
    {
      "value": "pinwall",
      "name": {
        "de": "Pinwand",
        "en": "Pinwall"
      },
      "privileges": {
        "name": "read",
        "value": "pinwall-messages"
      }
    },
    {
      "value": "media",
      "name": {
        "de": "Medien Bibliothek",
        "en": "Media Library"
      },
      "privileges": {
        "name": "read",
        "value": "assets"
      }
    },
    {
      "value": "dynamic-content",
      "name": {
        "de": "Inhalte",
        "en": "Content"
      },
      "privileges": {
        "name": "read",
        "value": "dynamic-content"
      }
    },
    {
      "value": "packages",
      "name": {
        "de": "Konfiguration",
        "en": "Configuration"
      },
      "privileges": {
        "name": "read",
        "value": "packages"
      }
    },
    {
      "value": "superadmin-packages",
      "name": {
        "de": "Package Konfiguration",
        "en": "Package Configuration"
      },
      "privileges": {
        "name": "superadmin",
        "value": "packages"
      }
    },
    {
      "value": "importer",
      "name": {
        "de": "Importer",
        "en": "Importer"
      },
      "privileges": {
        "name": "read",
        "value": "imports"
      }
    },
    {
      "value": "user-management",
      "name": {
        "de": "User Management",
        "en": "User Management"
      },
      "privileges": {
        "name": "write",
        "value": "organisations"
      }
    },
    {
      "value": "custom-json",
      "name": {
        "de": "Custom JSONs",
        "en": "Custom JSONs"
      },
      "privileges": {
        "name": "read",
        "value": "screens"
      }
    },
    {
      "value": "code-snippets",
      "name": {
        "de": "Code snippets",
        "en": "Code snippets"
      },
      "privileges": {
        "name": "read",
        "value": "code-snippets"
      }
    },
    {
      "value": "screen-settings",
      "name": {
        "de": "Screen Settings",
        "en": "Screen Settings"
      },
      "privileges": {
        "name": "read",
        "value": "legacy-screen-settings"
      }
    },
    {
      "value": "angie-screens",
      "name": {
        "de": "Angie Screens",
        "en": "Angie Screens"
      },
      "privileges": {
        "name": "read",
        "value": "angie-screens"
      }
    },
    {
      "value": "pipe-imports",
      "name": {
        "de": "Pipe Imports",
        "en": "Pipe Imports"
      },
      "privileges": {
        "name": "superadmin",
        "value": "pipe-imports"
      }
    },
    {
      "value": "analytics",
      "name": {
        "de": "Analytics",
        "en": "Analytics"
      },
      "privileges": {
        "name": "read",
        "value": "analytics"
      }
    }
  ]
}

